import { createI18n } from 'vue-i18n'
import en from "./locales/en/translations.json"
import de from "./locales/de/translations.json"
import cz from "./locales/cz/translations.json"
import dk from "./locales/dk/translations.json"
import es from "./locales/es/translations.json"
import fr from "./locales/fr/translations.json"
import frBE from "./locales/fr_BE/translations.json"
import hu from "./locales/hu/translations.json"
import it from "./locales/it/translations.json"
import nl from "./locales/nl/translations.json"
import nlBE from "./locales/nl_BE/translations.json"
import pl from "./locales/pl/translations.json"
import pt from "./locales/pt/translations.json"
/**
 * Load locale messages
 *
 * The loaded `JSON` locale messages is pre-compiled by `@intlify/vue-i18n-loader`, which is integrated into `vue-cli-plugin-i18n`.
 * See: https://github.com/intlify/vue-i18n-loader#rocket-i18n-resource-pre-compilation
 */
/* function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key).default
    }
  })
  return messages
} */

function getMyMessages() {
  return {
    en: en,
    de: de,
    cz: cz,
    dk: dk,
    es: es,
    fr: fr,
    fr_BE: frBE,
    hu: hu,
    it: it,
    nl: nl,
    nl_BE: nlBE,
    pl: pl,
    pt: pt
  }
}

export default createI18n({
  legacy: false,
  locale: process.env.VUE_APP_I18N_LOCALE || 'en',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: getMyMessages()
})
